// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myTasks_div{
    min-height: calc(100dvh - 100px);
    background-color: lightgrey;
    padding-bottom: 100px;
}
.myTasks_topSection{
    margin: auto;
    width: 90%;
    height: 15dvh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.5px solid grey;
}
.myTasks_userName{
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}
.myTasks_exitBtn{
    background-color: red;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    border: none;
    color: white;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}
.myTasks_exitBtn:hover{
    background-color: white;
    color: red;
    border: 0.5px solid red;
    box-shadow: 2px 2px 4px grey;
}
.myTasks_mainLogo{
    font-size: 35px;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    color: rgb(126, 191, 247);
    text-shadow: 2px 2px 3px rgb(13, 65, 111);
}
.myTasks_mainHeader{
    font-size: 45px;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    color: rgb(13, 65, 111);
    text-shadow: 2px 2px 3px grey;
}
.myTasks_time{
    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}
.myTasks_listDiv{
    margin: auto;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* task item */

.taskItem_div{
    min-width: 70%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin: 15px auto;
}
.taskItem_checkbox{
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin-left: 30px;
}
.taskItem_checkbox:hover{
    box-shadow: 2px 2px 4px grey;
}
.taskItem_content{
    margin: 0;
    font-size: 24px;
}

/* add task */

.addTask_div{
    width: 50%;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 20px auto 50px;
}
.addTask_inputs{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}
.addTask_content{
    width: 70%;
    height: 30px;
    font-size: 18px;
}
.addTask_constancy{
    margin: 0;
    width: 25px;
    height: 25px;
    cursor: pointer;
}
.addTask_constancy:hover{
    box-shadow: 1px 1px 3px grey;
}
.addTask_saveBtn{
    height: 25px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    background-color: rgb(126, 191, 247);
    color: white;
}
.addTask_saveBtn:hover{
    background-color: white;
    color: rgb(126, 191, 247);
    border: 0.5px solid rgb(126, 191, 247);
    box-shadow: 2px 2px 4px grey;
}

/* reset task && show history */
.resetTask_div, .showHistory_div{
    width: 80%;
    height: 35px;
}
.resetTask_div{
    margin: 40px auto 7px;
}
.showHistory_div{
    margin: 7px auto 40px;
    border-bottom: 0.5px solid rgb(13, 65, 111);
    padding-bottom: 10px;
}
.resetTask_btn, .showHistory_btn{
    width: 62.5%;
    height: 100%;
    background-color: rgb(13, 65, 111);
    border: none;
    color: white;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}
.resetTask_btn:hover, .showHistory_btn:hover{
    color: rgb(13, 65, 111);
    background-color: white;
    border: 0.5px solid rgb(13, 65, 111);
    box-shadow: 2px 2px 4px grey;
}`, "",{"version":3,"sources":["webpack://./src/components/style/myTasks.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,+CAA+C;IAC/C,yBAAyB;IACzB,yCAAyC;AAC7C;AACA;IACI,eAAe;IACf,+CAA+C;IAC/C,uBAAuB;IACvB,6BAA6B;AACjC;AACA;IACI,4EAA4E;AAChF;AACA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,cAAc;;AAEd;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA,+BAA+B;AAC/B;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;AAChC","sourcesContent":[".myTasks_div{\n    min-height: calc(100dvh - 100px);\n    background-color: lightgrey;\n    padding-bottom: 100px;\n}\n.myTasks_topSection{\n    margin: auto;\n    width: 90%;\n    height: 15dvh;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 0.5px solid grey;\n}\n.myTasks_userName{\n    margin: 0;\n    font-size: 18px;\n    font-weight: bold;\n}\n.myTasks_exitBtn{\n    background-color: red;\n    width: 100px;\n    height: 35px;\n    border-radius: 20px;\n    border: none;\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n}\n.myTasks_exitBtn:hover{\n    background-color: white;\n    color: red;\n    border: 0.5px solid red;\n    box-shadow: 2px 2px 4px grey;\n}\n.myTasks_mainLogo{\n    font-size: 35px;\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\n    color: rgb(126, 191, 247);\n    text-shadow: 2px 2px 3px rgb(13, 65, 111);\n}\n.myTasks_mainHeader{\n    font-size: 45px;\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\n    color: rgb(13, 65, 111);\n    text-shadow: 2px 2px 3px grey;\n}\n.myTasks_time{\n    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n}\n.myTasks_listDiv{\n    margin: auto;\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n/* task item */\n\n.taskItem_div{\n    min-width: 70%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    margin: 15px auto;\n}\n.taskItem_checkbox{\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    margin-left: 30px;\n}\n.taskItem_checkbox:hover{\n    box-shadow: 2px 2px 4px grey;\n}\n.taskItem_content{\n    margin: 0;\n    font-size: 24px;\n}\n\n/* add task */\n\n.addTask_div{\n    width: 50%;\n    height: 70px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 20px auto 50px;\n}\n.addTask_inputs{\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n}\n.addTask_content{\n    width: 70%;\n    height: 30px;\n    font-size: 18px;\n}\n.addTask_constancy{\n    margin: 0;\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n}\n.addTask_constancy:hover{\n    box-shadow: 1px 1px 3px grey;\n}\n.addTask_saveBtn{\n    height: 25px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    border: none;\n    background-color: rgb(126, 191, 247);\n    color: white;\n}\n.addTask_saveBtn:hover{\n    background-color: white;\n    color: rgb(126, 191, 247);\n    border: 0.5px solid rgb(126, 191, 247);\n    box-shadow: 2px 2px 4px grey;\n}\n\n/* reset task && show history */\n.resetTask_div, .showHistory_div{\n    width: 80%;\n    height: 35px;\n}\n.resetTask_div{\n    margin: 40px auto 7px;\n}\n.showHistory_div{\n    margin: 7px auto 40px;\n    border-bottom: 0.5px solid rgb(13, 65, 111);\n    padding-bottom: 10px;\n}\n.resetTask_btn, .showHistory_btn{\n    width: 62.5%;\n    height: 100%;\n    background-color: rgb(13, 65, 111);\n    border: none;\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n}\n.resetTask_btn:hover, .showHistory_btn:hover{\n    color: rgb(13, 65, 111);\n    background-color: white;\n    border: 0.5px solid rgb(13, 65, 111);\n    box-shadow: 2px 2px 4px grey;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
